import * as React from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import { Radio, Icon, Tooltip } from 'antd';
import { withRouter } from 'react-router';
import { getAllInquiriesSetFilter, getAllInquiriesApplyFilter }
from 'src/actions/inquiryShipperActions';
import { bindActionCreators } from 'redux';

const styles = theme => ({
  mainDiv: {
    background: 'white',
    position: 'absolute',
    zIndex: 10,
    marginTop: '-11px',
    width: '20%',
    marginLeft: '40%',
    padding: 16,
    display: 'flex',
    border: '1px solid #D9D9D9',
    flexDirection: 'column',
    boxShadow: '2px 2px 2px 0 rgba(0, 0, 0, 0.08)',
    '& .ant-calendar-picker-input': {
      padding: 0,
    },
  },
});

class InquiryShipperSortPopup extends React.PureComponent<any, any> {
  onChange = (e) => {
    this.props.getAllInquiriesSetFilter({
      sortBy: e.target.value,
      descendingOrder: true,
    });
    this.props.closeFilter();
    this.props.getAllInquiriesApplyFilter();
  }

  node: any = React.createRef();

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClose, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClose, false);
  }

  handleClose = (e) => {
    if (this.node.contains(e.target)) {
      return;
    }
    this.handleClickOutside();
  }

  handleClickOutside() {
    this.props.closeFilter();
  }

  handleOrder = (val) => {
    val === 'asc'
      ? this.props.getAllInquiriesSetFilter({ descendingOrder: false })
      : this.props.getAllInquiriesSetFilter({ descendingOrder: true });
    this.props.closeFilter();
    this.props.getAllInquiriesApplyFilter();
  }

  renderOrderIcons() {
    const { appliedFilters } = this.props;
    return (
      <div
        style={{
          display: 'flex',
          width: '20px',
          justifyContent: 'space-between',
        }}
      >
        <Tooltip placement="top" title="Ascending Order">
          <Icon
            type="caret-up"
            onClick={
              appliedFilters.descendingOrder === true
                ? () => this.handleOrder('asc')
                : undefined
            }
            style={{
              float: 'left',
              marginTop: '5px',
              height: '8px',
              width: '8px',
              color: `${
                appliedFilters.descendingOrder === true
                  ? '#505050a6'
                  : '#000000'
              }`,
            }}
          />
        </Tooltip>
        <Tooltip placement="top" title="Descending Order">
          <Icon
            type="caret-down"
            onClick={
              appliedFilters.descendingOrder === false
                ? () => this.handleOrder('desc')
                : undefined
            }
            style={{
              float: 'left',
              marginTop: '5px',
              height: '8px',
              width: '8px',
              color: `${
                appliedFilters.descendingOrder === true
                  ? '#000000'
                  : '#505050a6'
              }`,
            }}
          />
        </Tooltip>
      </div>
    );
  }

  render() {
    const radioStyle = {
      display: 'inline-block',
      height: '30px',
      lineHeight: '30px',
    };
    const options = [
      ['created_at', 'Created Date'],
      ['deadline', 'Closing Date'],
      ['latest_bid_received', 'Latest Bids Received'],
    ];
    const { classes, appliedFilters } = this.props;
    return (
      <div className={classes.mainDiv} ref={node => (this.node = node)}>
        <Radio.Group
          onChange={this.onChange}
          value={this.props.appliedFilters.sortBy}
          disabled={this.props.loading}
        >
          {options.map((item) => {
            return (
              <div
                key={item[0]}
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <div>
                  <Radio style={radioStyle} value={item[0]}>
                    {item[1]}
                  </Radio>
                </div>
                {this.props.appliedFilters.sortBy === item[0] &&
                !this.props.loading
                  ? this.renderOrderIcons()
                  : null}
              </div>
            );
          })}
        </Radio.Group>
      </div>
    );
  }
}

const InquiryShipperSortPopupStyled = injectSheet(styles)(
  InquiryShipperSortPopup,
);
const mapStateToProps = ({ inquiryShipperReducer }, ownProps) => ({
  filters: inquiryShipperReducer.selectedFilters,
  appliedFilters: inquiryShipperReducer.appliedFilters,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllInquiriesSetFilter,
      getAllInquiriesApplyFilter,
    },
    dispatch,
  );
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(InquiryShipperSortPopupStyled),
);
